import React, { Component } from "react";
import { observer } from "mobx-react";

import firebase from "firebase/app";
import firebaseui from "firebaseui";

import 'firebaseui/dist/firebaseui.css';

@observer
export default class Login extends Component {
  ui = null;

  startLogin = () => {
    var uiConfig = {
      signInSuccessUrl: "/",
      signInOptions: [
        firebase.auth.GoogleAuthProvider.PROVIDER_ID,
        firebase.auth.EmailAuthProvider.PROVIDER_ID
      ]
    };

    //let ui = firebaseui.auth.AuthUI.getInstance();
    //if (!ui) {
    //  ui = new firebaseui.auth.AuthUI(firebase.auth());
    //}

    var ui = new firebaseui.auth.AuthUI(firebase.auth());
    ui.start('#firebase-ui', uiConfig);

  };

  componentDidMount() {
    this.startLogin();
  }

  componentWillUnmount() {
    firebaseui.auth.AuthUI.getInstance().delete();
  }

  render() {
    return <div className='login-screen'> Login Screen </div>;
  }
}



// WEBPACK FOOTER //
// ./src/components/Login.jsx